import { Application } from '../../application';
import { Event } from '../event';

export class ApplicationLifecycleEvent extends Event {
  public constructor (private readonly application: Application) {
    super();
  }

  public getApplication (): Application {
    return this.application;
  }
}
